// Safemode script: adjust the page title for specific cases without touching Liquid templates.
// If the generated title is "Hitch - Hitch" (case insensitive), replace it with uppercase "HITCH".
document.addEventListener('DOMContentLoaded', function() {
  try {
    var currentTitle = document.title.trim();
    // Match "Hitch - Hitch" or variations in case and spacing
    if (/^hitch\s*-\s*hitch$/i.test(currentTitle)) {
      document.title = 'HITCH';
    }
  } catch (err) {
    console.error('safemode-title-fix error:', err);
  }
});